import {
  CSSProperties,
  FocusEventHandler,
  ForwardedRef,
  KeyboardEventHandler,
  PropsWithoutRef,
  ReactNode,
  Ref,
  forwardRef,
} from 'react';
import { ValueDisplay, ValueWrapper } from './TypeaheadTrigger.styles';

type TypeaheadTriggerProps = {
  isDisabled: boolean;
  placeholder?: string;
  ref?: Ref<HTMLDivElement>;
  style?: CSSProperties;
  autoFocus?: boolean;
  Prefix?: ReactNode;
  Suffix?: ReactNode;
  maxLength?: number;
  value: string;
  onSearch: (text: string) => void;
  onFocus: FocusEventHandler<HTMLDivElement>;
  onKeyPress: KeyboardEventHandler<HTMLInputElement>;
};

export const TypeaheadTrigger = forwardRef(function InnerSelectValue(
  {
    isDisabled = false,
    placeholder = '',
    value,
    onSearch,
    onFocus,
    onKeyPress,
    autoFocus = false,
    Prefix = null,
    Suffix = null,
    maxLength,
  }: PropsWithoutRef<TypeaheadTriggerProps>,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <ValueWrapper ref={ref} onFocus={onFocus}>
      <ValueDisplay
        id="typeahead-input"
        isDisabled={isDisabled}
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={onSearch}
        onKeyDown={onKeyPress}
        autoComplete="off"
        autoFocus={autoFocus}
        Prefix={Prefix}
        Suffix={Suffix}
        maxLength={maxLength}
      />
    </ValueWrapper>
  );
});
